'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.module = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _immutable = require('immutable');

var _browser = require('invariant/browser');

var _browser2 = _interopRequireDefault(_browser);

var _dispatcher = require('../dispatcher');

var _dispatcher2 = _interopRequireDefault(_dispatcher);

var _utils = require('flux/utils');

var _events = require('../events');

var _events2 = _interopRequireDefault(_events);

var _actions = require('./actions');

var _deserialize = require('../events/deserialize');

var _deserialize2 = _interopRequireDefault(_deserialize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * TODO: Convert to storing per feis
 */
var SyllabusStore = function (_Store) {
  _inherits(SyllabusStore, _Store);

  function SyllabusStore(dispatcher) {
    _classCallCheck(this, SyllabusStore);

    var _this = _possibleConstructorReturn(this, (SyllabusStore.__proto__ || Object.getPrototypeOf(SyllabusStore)).call(this, dispatcher));

    _this._data = (0, _immutable.Map)({
      feis: {},

      /**
       * Houses a list of all event names, for expediency.
       */
      eventNames: (0, _immutable.List)([]),

      /**
       * A map of all events, by id.
       */
      events: (0, _immutable.Map)({})
    });

    _this._types = (0, _immutable.List)([{
      value: 'G',
      label: 'Grades',
      hasLevels: true,
      levelsLabel: 'Level'
    }, {
      value: 'C',
      label: 'Championships',
      hasLevels: false
    }, {
      value: 'F',
      label: 'Figures',
      hasLevels: false
    }, {
      value: 'S',
      label: 'Specials',
      hasLevels: true,
      levelsLabel: 'Category'
    }]);
    return _this;
  }

  _createClass(SyllabusStore, [{
    key: '_seed',
    value: function _seed(feis, events) {
      var newEventsMap = (0, _immutable.Map)(events.map(_deserialize2.default).map(function (e) {
        return [e.id, (0, _immutable.Map)(e)];
      }));
      var newEventNames = (0, _immutable.List)(events.map(function (e) {
        return e.name;
      }));

      this._data = this._data.set('feis', feis).set('events', newEventsMap).set('eventNames', newEventNames);

      this.__emitChange();
    }
  }, {
    key: '_add',
    value: function _add(event) {
      var newEventNames = this._data.get('eventNames').push(event.name);

      this._data = this._data.setIn(['events', event.id], (0, _immutable.Map)((0, _deserialize2.default)(event))).set('eventNames', newEventNames);

      this.__emitChange();
    }
  }, {
    key: '_update',
    value: function _update(event) {
      this._data = this._data.setIn(['events', event.id], (0, _immutable.Map)((0, _deserialize2.default)(event)));

      var newEventNames = this._data.get('events').toList().map(function (e) {
        return e.get('name');
      });

      this._data = this._data.set('eventNames', newEventNames);

      this.__emitChange();
    }
  }, {
    key: '_remove',
    value: function _remove(event) {
      var newEventNames = this._data.get('eventNames').filter(function (e) {
        return e !== event.name;
      });

      this._data = this._data.deleteIn(['events', event.id]).set('eventNames', newEventNames);

      this.__emitChange();
    }
  }, {
    key: 'getFeis',
    value: function getFeis() {
      var feis = this._data.get('feis');
      (0, _browser2.default)(feis && feis.id, 'SyllabusStore should not be accessed before it is seeded.');

      return feis;
    }
  }, {
    key: 'getData',
    value: function getData() {
      return this._data;
    }
  }, {
    key: 'getTypes',
    value: function getTypes() {
      return this._types;
    }

    /**
     * This is the method that handles events from the Dispatcher. All mutations start here!
     */

  }, {
    key: '__onDispatch',
    value: function __onDispatch(_ref) {
      var actionType = _ref.actionType,
          payload = _ref.payload,
          context = _objectWithoutProperties(_ref, ['actionType', 'payload']);

      switch (actionType) {
        case _actions.CREATE_SYLLABUS_SUCCESS:
          this._add(payload);
          break;

        case _actions.UPDATE_SYLLABUS_SUCCESS:
          this._update(payload);
          break;

        case _actions.REMOVE_SYLLABUS_SUCCESS:
          this._remove(payload);
          break;

        case _actions.SEED_SYLLABUS_SUCCESS:
          this._seed(payload.feis, payload.events);
          break;

        // TODO: support seeding from local storage
      }
    }
  }]);

  return SyllabusStore;
}(_utils.Store);

var _module = _angular2.default.module('ifeis.syllabi.store', []).service('syllabusStore', SyllabusStore);

exports.module = _module;
exports.default = SyllabusStore;


//////////////////
// WEBPACK FOOTER
// ./syllabus/store.js
// module id = 610
// module chunks = 0